import theme from '../base'

const timeline = {
  MuiTimeline: {
    styleOverrides: {
      root: {
        margin: 0,
      },
    },
  },
  MuiTimelineItem: {
    styleOverrides: {
      root: {
        minHeight: theme.spacing(5),
        padding: theme.spacing(0, 2),
        '& .MuiTypography-root': {
          minHeight: 22,
          lineHeight: '22px',
          '&.heading': {
            fontWeight: 700,
          },
        },
        '&.past': {
          '& .MuiTypography-h4': {
            color: theme.palette.green.darkest,
          },
          '& .MuiTimelineDot-root': {
            backgroundColor: theme.palette.green.dark,
            borderColor: theme.palette.green.dark,
          },
          '& .MuiTimelineConnector-root': {
            borderLeftStyle: 'solid',
            borderLeftColor: theme.palette.green.dark,
          },
        },
        '&.current': {
          '& .MuiTypography-h4': {
            color: theme.palette.turquoise.darkest,
          },
          '& .MuiTimelineSeparator-root': {
            '& svg': {
              marginTop: 10,
              marginBottom: 8,
              color: theme.palette.info.dark,
            },
          },
        },
      },
    },
  },
  MuiTimelineContent: {
    styleOverrides: {
      root: {
        color: theme.palette.neutral.main,
      },
    },
  },
  MuiTimelineOppositeContent: {
    styleOverrides: {
      root: {
        color: theme.palette.neutral.main,
      },
    },
  },
  MuiTimelineSeparator: {
    styleOverrides: {
      root: {
        minWidth: theme.spacing(4),
      },
    },
  },
  MuiTimelineDot: {
    styleOverrides: {
      root: {
        position: 'relative',
        alignSelf: 'auto',
        boxShadow: 'none',
        borderWidth: 1,
      },
      filledGrey: {
        width: 6,
        height: 6,
        marginTop: 14,
        marginBottom: 12,
        padding: 0,
        backgroundColor: theme.palette.neutral.lighter,
      },
      outlinedGrey: {
        marginTop: 12,
        padding: 2,
        borderColor: theme.palette.neutral.lighter,
        '&:after': {
          content: '""',
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: theme.palette.neutral.lighter,
        },
      },
    },
  },
  MuiTimelineConnector: {
    styleOverrides: {
      root: {
        width: 2,
        backgroundColor: 'transparent',
        borderLeft: `1px dashed ${theme.palette.neutral.lighter}`,
      },
    },
  },
}

export default timeline
